import { authApi, defaultApi } from 'api';
import { clearSession } from 'services/auth/tokenService';

export const createSubscriptionAccount = async (userData) => {
  return (await defaultApi.post('/Auth/create-account', userData)).data;
};

export const createMemberAccount = async (userData) => {
  return (await defaultApi.post('/Auth/register', userData)).data;
};

export const checkOnboardingStatus = async (email) => {
  return await defaultApi.post('/Auth/check-onboarding-status', { email });
};

export const confirmInvitation = async (clubID, email, code) => {
  return await defaultApi.post(`/auth/confirm-invitation`, {
    clubID,
    email,
    code,
  });
};

export const getMemberInfoForSetPassword = async (email) => {
  return await authApi.get(
    `/auth/member-info-for-setpassword?email=${encodeURIComponent(email)}`
  );
};

// Sets the password for a new user, optionally including first and last name if they are provided.
export const setPassword = async (
  email,
  password,
  firstName = null,
  lastName = null
) => {
  const payload = {
    email,
    newPassword: password,
  };

  // Only include name fields if provided
  if (firstName) {
    payload.firstName = firstName;
  }
  if (lastName) {
    payload.lastName = lastName;
  }

  return await authApi.post(`/auth/set-password`, payload);
};

export const forgotPassword = async (email) => {
  return await authApi.post(`/auth/forgot-password`, { email });
};

export const resetPassword = async (
  email,
  code,
  newPassword,
  firstName = null,
  lastName = null
) => {
  const payload = {
    email,
    code,
    newPassword,
  };

  // Only include name fields if provided
  if (firstName) {
    payload.firstName = firstName;
  }
  if (lastName) {
    payload.lastName = lastName;
  }

  return await authApi.post(`/auth/reset-password`, payload);
};

// In-app password change for a logged-in user (personal-portal "Reset my password").
export const changePassword = async (currentPassword, newPassword) => {
  return await authApi.post(`/auth/change-password`, {
    currentPassword,
    newPassword,
  });
};

export const login = async (credential) => {
  return await defaultApi.post('/Auth/login', credential);
};

export const logout = async () => {
  clearSession();
};
